module.exports = __webpack_public_path__ + "static/media/MyTasksCompleted.94873e49.svg";